/**
 * Runtime configuration.
 *
 * The API base used to be baked into the bundle at build time via
 * VUE_APP_BASE_URL, which meant one image per environment and per brand.
 * It is now read from `window.__APP_CONFIG__`, which `public/config.js`
 * sets before the bundle runs. The container rewrites that file on start
 * from the API_BASE_URL environment variable, so a single image can serve
 * staging, production and the whitelabels.
 *
 * The build-time value is kept as a fallback, so an image built and run
 * without config.js behaves exactly as it did before.
 */

export interface AppConfig {
  apiBaseUrl?: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

const BUILD_TIME_FALLBACK = 'https://api.default.kairosafrika.cloud';

/**
 * Read at call time, never cached at module scope: config.js is loaded by a
 * plain script tag, and reading lazily keeps this correct regardless of
 * module evaluation order.
 */
export function apiBaseUrl(): string {
  const fromRuntime = window.__APP_CONFIG__?.apiBaseUrl;
  if (fromRuntime && fromRuntime.trim()) return fromRuntime.trim();
  return process.env.VUE_APP_BASE_URL || BUILD_TIME_FALLBACK;
}

/**
 * Base for static files. The API registers /static/* before setGlobalPrefix,
 * so those sit above the app's own /api prefix and only that segment is
 * dropped. Any other path stays: a whitelabel served under /teksol keeps it,
 * because there the prefix is the ingress route, not the app's.
 */
export function assetBaseUrl(): string {
  return apiBaseUrl().replace(/\/api$/, '');
}

export default { apiBaseUrl, assetBaseUrl };
